<template>
  <div class="evaluation-list-page">
    <van-pull-refresh
      v-model="refreshing"
      @refresh="onRefresh"
      success-duration="1000"
      success-text="刷新成功"
    >
      <template v-if="hasData">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text=""
          :error="error"
          error-text="加载失败..."
          :immediate-check="false"
          @load="onLoad"
        >
          <template v-if="list.length > 0">
            <evaluationCard v-for="(item, index) in list" :key="index" :itemData="item" />
          </template>
        </van-list>
      </template>
      <emptyData v-else emptyName="noEvaluation" />
    </van-pull-refresh>
  </div>
</template>

<script>
// eslint-disable-next-line import/extensions
import evaluationCard from '@/components/commonComponents/evaluationCard';
import { reqGetEvaluationGuidance, reqGetEvaluationProduct } from '@/api/learningGuidePage';
// eslint-disable-next-line import/extensions
import emptyData from '@/components/emptyData/emptyData';
import { data } from 'autoprefixer';

export default {
  components: { evaluationCard, emptyData },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageNum: 1,
      error: false,
      hasData: true,
    };
  },
  props: ['source'],
  mounted() {
    this.hasData = true;
    this.loading = true;
    this.onLoad();
  },
  methods: {
    async onLoad() {
      try {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
        const { courseId, teacherId } = this.$route.query;
        const entryType = this.$route.query.entryType || 1;
        if (this.source === 'product') {
          // 产品详情页评价
          const res = await reqGetEvaluationProduct(this.$route.query.courseId, this.pageNum, 20);
          if (res.code === 0) {
            if (res.data.total === 0) {
              this.$parent.$data.isAddEvaluation = true;
            }
            this.loading = false;
            this.list = this.list.concat(res.data.data);
            if (this.pageNum >= res.data.pages) {
              this.finished = true;
            }
            this.pageNum += 1;
            this.hasData = res.data.total > 0;
            this.$emit('evaluationTotal', res.data.total);
          } else {
            this.loading = false;
            this.error = true;
          }
        } else if (entryType) {
          // 导学页评价
          let params = '';
          if (Number(entryType) === 1) {
            params = `?entryType=${entryType}&productId=${courseId}`;
          } else {
            params = `?entryType=${entryType}&teacherId=${teacherId}`;
          }
          const res = await reqGetEvaluationGuidance(params);
          this.finished = true;
          this.loading = false;
          if (!res?.data) {
            this.$parent.$data.isAddEvaluation = true;
          } else {
            this.list = [res.data];
          }
        }
      } catch (error) {
        this.$toast(error.message);
      }
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.pageNum = 1;
      this.onLoad();
    },
  },
};
</script>

<style scoped lang="scss">
.evaluation-list-page {
  min-height: calc(100vh - 100px);
  padding: 36px;
  background: $bgColor;

  .van-pull-refresh {
    min-height: calc(100vh - 100px);
  }
}
</style>
